import ComponentsKreditdataRedirectButton from './ComponentsKreditdataRedirectButton';

export default ComponentsKreditdataRedirectButton;
